export const getQueryVariable = (name, locationSearch) => {
  const query = locationSearch.substring(1);
  const vars = query.split('&');
  for (const variable of vars) {
    const pair = variable.split('=');
    if (decodeURIComponent(pair[0]) === name) {
      return decodeURIComponent(pair[1]);
    }
  }
};

export const formatThousands = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const getCookie = (name) => {
  if (new RegExp(name + '=([^;]*);', '').test(document.cookie + ';')) {
    return decodeURIComponent(RegExp.$1);
  }
  return null;
};
